import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import authService from "../../auth/authService";
import { getCookie } from "../../../function";
import { jwtDecode } from "jwt-decode";
import { VscThreeBars } from "react-icons/vsc";
import { GrArticle } from "react-icons/gr";
import { IoIosLogOut } from "react-icons/io";
import { FaRocketchat } from "react-icons/fa";
import { IoIosChatboxes } from "react-icons/io";
import { BsFillJournalBookmarkFill } from "react-icons/bs";
import { FaRegUserCircle, FaBell, FaRegUser } from "react-icons/fa";
import { MdDashboard } from "react-icons/md";
import { IoMdCalculator } from "react-icons/io";
import { FaCog } from "react-icons/fa";
import { MdPayment } from "react-icons/md";
import NotificationPanel from "../Notification/Notification";

// Icons for role badge
import { Shield, Edit, Users } from "lucide-react";
import axios from "axios";
import { API_URL } from "../../../config";

const SideBar = () => {
  const [token, setToken] = useState(getCookie("token"));
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);
  const [show, setShow] = useState(false);
  const [refundCount, setRefundCount] = useState({});

  const decodedToken = token ? jwtDecode(token) : null;
  const role = decodedToken?.user?.userType || "admin";
  console.log("decodedToken", decodedToken);
  const UserRole =
    decodedToken?.user?.userType === "admin"
      ? "Admin"
      : decodedToken?.user?.userType === "tl"
      ? "Team Lead"
      : "Editor";

  const handleNotificationClick = () => setShow(true);
  const handleCloseNotification = () => setShow(false);
  const handleLogOut = () => authService.logout();
  const toggleSidebar = () => setIsCollapsed((prev) => !prev);

  const getRoleIcon = () => {
    switch (role) {
      case "admin":
        return <Shield className="h-3 w-3" />;
      case "user":
        return <Edit className="h-3 w-3" />;

      default:
        return <Shield className="h-3 w-3" />;
    }
  };

  const getRoleColor = () => {
    switch (role) {
      case "admin":
        return "text-danger";
      case "user":
        return "text-primary";
      default:
        return "text-secondary";
    }
  };

  const sidebarOptions = [
    {
      name: "Dashboard",
      path: "/admin/dashboard",
      icon: <MdDashboard className="me-2" />,
      role: ["1", "2", "tl", "admin", "user"],
    },
    {
      name: "Calculation",
      path: "/admin/calculation",
      icon: <IoMdCalculator className="me-2" />,
      role: ["1", "admin"], // only admin
    },
    {
      name: "Submitted Invoice",
      path:
        decodedToken?.user?.userType === "admin"
          ? // || decodedToken?.user?.journal?.includes("2834823r827r")
            "/admin/client-articles"
          : "/admin/articles",
      icon: <GrArticle className="me-2" />,
      role: ["1", "2", "tl", "admin", "user"],
    },
    // {
    //   name: "Client Chats",
    //   path: "/admin/chat-list",
    //   icon: <IoIosChatboxes className="me-2" />,
    //   role: ["1"],
    // },
    // {
    //   name: "Payment Chats",
    //   path: "/admin/payment-chat",
    //   icon: <FaRocketchat className="me-2" />,
    //   role: ["2"],
    // }
    {
      name: "Publication",
      path: "/admin/publication",
      icon: <BsFillJournalBookmarkFill className="me-2" />,
      role: ["admin", "user"], // not for tl
    },
    {
      name: "Tools",
      path: "/admin/handler",
      icon: <FaCog className="me-2" />,
      role: ["1", "2", "tl", "admin", "user"], // allow for all roles
    },
    {
      name: "Candidate",
      path: "/admin/Client",
      icon: <FaRegUser className="me-2" />,
      role: ["admin", "user"], // not for tl
    },
    {
      name: "User",
      path: "/admin/user",
      icon: <FaRegUserCircle className="me-2" />,
      role: ["admin", "user"], // not for tl
    },
    {
      name: "Refund Requests",
      path: "/admin/refunds",
      icon: <MdPayment className="me-2" />,
      role: ["1", "2", "admin", "user"], // not for tl
      badge: (
        <div className="d-flex gap-1 mt-1 ms-4">
          <span className="badge bg-warning">
            {refundCount.pendingCount || 0}
          </span>
          <span className="badge bg-success">
            {refundCount.approvedCount || 0}
          </span>
          {/* <span className="badge bg-danger">
            {refundCount.rejectedCount || 0}
          </span>
          <span className="badge bg-info">
            {refundCount.completedCount || 0}
          </span> */}
        </div>
      ),
    },
  ];

  const fetchRefundCount = async () => {
    const response = await axios.get(
      `${API_URL}/refundCount?id=${decodedToken.user.id}`,
      {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": "JjgeTensKk20J7GIxBfMSaA25Aricvmr1HYmjxpS",
          Authorization: getCookie("token"),
        },
      }
    );

    console.log(response);
    const parsedData = JSON.parse(response.data);
    const result = JSON.parse(parsedData.body);
    console.log("hello", result);

    if (result.success) {
      setRefundCount(result.data);
    }
  };

  useEffect(() => {
    fetchRefundCount();
  }, []);
  return (
    <div
      className={`d-flex flex-column flex-shrink-0 p-3 text-white sidebar ${
        isCollapsed ? "collapsed" : ""
      }`}
      style={{ backgroundColor: "#1d3256" }}
    >
      <div className="d-flex justify-content-between align-items-center">
        <div
          onClick={toggleSidebar}
          className="d-flex align-items-center text-white text-decoration-none hover-opacity"
        >
          <div
            className="d-flex align-items-center justify-content-center me-3 rounded shadow-sm"
            style={{
              width: "32px",
              height: "32px",
              background: "linear-gradient(to bottom right, #60a5fa, #8b5cf6)",
            }}
          >
            <div
              className="d-grid"
              style={{ gridTemplateColumns: "repeat(2, 1fr)", gap: "2px" }}
            >
              <div
                className="bg-white rounded opacity-90"
                style={{ width: "6px", height: "6px" }}
              />
              <div
                className="bg-white rounded opacity-70"
                style={{ width: "6px", height: "6px" }}
              />
              <div
                className="bg-white rounded opacity-70"
                style={{ width: "6px", height: "6px" }}
              />
              <div
                className="bg-white rounded opacity-90"
                style={{ width: "6px", height: "6px" }}
              />
            </div>
          </div>
          {!isCollapsed && (
            <Link
              to="/admin/dashboard"
              className=""
              style={{ textDecoration: "none" }}
            >
              <div className="d-flex flex-column">
                <span className="fw-semibold text-white">Account Panel</span>
                <div
                  className={`d-flex align-items-center gap-1 small fw-medium ${getRoleColor()}`}
                >
                  {getRoleIcon()}
                  <span className="text-capitalize">{UserRole}</span>
                </div>
              </div>
            </Link>
          )}
        </div>
      </div>

      <hr />

      <ul className="nav nav-pills flex-column mb-auto">
        {/* Notification only for admin and editor */}
        {(role === "admin" || role === "user") && (
          <li className="nav-item">
            <button
              className="btn btn-link nav-link text-white"
              onClick={() => handleNotificationClick(true)}
            >
              <FaBell className="me-2" />
              {!isCollapsed && "Notification"}
              {unreadCount > 0 && (
                <span className="badge bg-danger rounded-pill ms-2">
                  {unreadCount}
                </span>
              )}
            </button>
          </li>
        )}

        {sidebarOptions.map((option, index) => {
          // Only show options for the user's role
          if (
            (role === "admin" &&
              (!option.role || option.role.includes("admin"))) ||
            (role === "user" && option.role?.includes("user")) ||
            (role === "tl" && option.role?.includes("tl"))
          ) {
            return (
              <li key={index} className="nav-item">
                <Link to={option.path} className="nav-link text-white">
                  <div className="d-flex align-items-center">
                    {option.icon}
                    {!isCollapsed && option.name}
                  </div>
                  {!isCollapsed && option.badge}
                </Link>
              </li>
            );
          }
          return null;
        })}
      </ul>

      {/* Log out button at the bottom */}
      <div className="mt-auto p-3">
        <Link
          to="#"
          className="nav-link text-white d-flex align-items-center"
          onClick={handleLogOut}
        >
          <IoIosLogOut className="me-2" />
          {!isCollapsed && "Log out"}
        </Link>
      </div>

      {/* NotificationPanel only for admin and editor */}
      {(role === "admin" || role === "user") && (
        <NotificationPanel
          show={show}
          onHide={handleCloseNotification}
          setUnreadCount={setUnreadCount}
        />
      )}
    </div>
  );
};

export default SideBar;
